export class TagAddressNotesBulk {
  masterDocumentSourceIds: number[];
  manageTagNotes: string;

  constructor(options: {
    masterDocumentSourceIds: number[];
    manageTagNotes: string;
    }) {
    this.masterDocumentSourceIds = options.masterDocumentSourceIds;
    this.manageTagNotes = options.manageTagNotes;
    }
}
